module.exports = __webpack_public_path__ + "img/Ventuar_Metal Mace.e997b8f0.png";